import { useState, useEffect, useRef, useCallback } from 'react';
/**
 * Custom hook to dynamically adjust the height of an iframe based on its content.
 * Provides a function to manually start observing the iframe's body
 *
 * @param minIframeHeight - Minimum height of the iframe.
 * @returns Object containing the current iframe height and a function to start observing the iframe content.
 */
export const useIframeResize = (minIframeHeight) => {
    const [iframeHeight, setIframeHeight] = useState(minIframeHeight);
    const observer = useRef(null);
    const startObserving = useCallback((elem) => {
        var _a, _b, _c;
        if (!((_a = elem.contentDocument) === null || _a === void 0 ? void 0 : _a.body))
            return;
        (_b = observer.current) === null || _b === void 0 ? void 0 : _b.observe((_c = elem.contentDocument) === null || _c === void 0 ? void 0 : _c.body);
    }, []);
    useEffect(() => {
        observer.current = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const { clientHeight } = entry.target;
                if (clientHeight) {
                    setIframeHeight(clientHeight);
                }
            });
        });
        return () => { var _a; return (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect(); };
    }, []);
    return { iframeHeight, startObserving };
};
